import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import ReactLoading from 'react-loading';
import PrimaryTable from '../helpers/primary-table'
import { useNavigate } from "react-router-dom";
import { catchError } from '../helpers/catch-error'

    
const roleLabel = (role) => {
    switch (Number(role)) {
        case 1:
            return "Admin";
        case 2:
            return "Client";
        case 3:
            return "Case Manager";
        default:
            return "";
    }
};
const formatDateTime = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return value;

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const time = d.toLocaleString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    return `${dd}/${mm}/${d.getFullYear()} ${time}`;
};
const LoginLogs = () => {
    const navigate = useNavigate();
   
    var columns = React.useMemo(
        () => [
            {
                accessorKey: "user_email",
                header: "EMAIL",
                footer: props => props.column.id
            },
             {
                accessorFn: row => roleLabel(row.role),
                id: "role",
                cell: info => info.getValue(),
                header: () => "ROLE",
                footer: props => props.column.id
            },
             {
                accessorKey: "user_device",
                header: "Device",
                footer: props => props.column.id
            },
             {
    accessorFn: row => formatDateTime(row.log_datetime),
    id: "log_datetime",
    header: "Login Time",
    cell: info => info.getValue(),
    footer: props => props.column.id
},
{
    accessorFn: row => formatDateTime(row.logout_at),
    id: "logout_at",
    header: "Logout/Left At",
    cell: info => info.getValue(),
    footer: props => props.column.id
},
           
           
        ],
        []
    )


    const [isLoading, setIsLoading] = useState(true);
    const [Logs, setLogs] = useState(null);
   

    useEffect(() => {

        getLogs();


    }, []);


    const getLogs = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-login-logs",
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {
                if (response?.data?.status) {
                    setLogs(response?.data?.logs)
                    setIsLoading(false);
                } else {
                    Swal.fire({ icon: "error", title: "Logs Info", text: response?.data?.message });
                    setIsLoading(false);
                }
            }).catch(function (error) {
                catchError(error, navigate)
            });


    }




    return (

        <>
            <div className="row pb-2 mt-4">
                <div className="col-md-4 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">Login Logs</h3>
                </div>

              
            </div>



            {isLoading ?
                <div className="container text-center">
                    <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
                </div>
                :
                <>


                    {Logs &&
                        <>
                            <div className="card card-form card-primary  h-100 " >
                                <div className="card-body p-0 mb-5" >


                                    <PrimaryTable columns={columns} data={Logs} />
                                </div></div>
                        </>
                    }
                </>
            }


        </>

    )

}

export default LoginLogs;